<template>
    <div class="final-crisis">
        <div v-if="isCompleted" class="final-crisis-header">
            <div class="crisis-header-left">
                <img :src="require('@/assets/icons/pr-completed.svg')" />
                <div class="completed-msg">
                    <h2 class="title">Crisis generated</h2>
                </div>
            </div>

            <div class="crisis-header-right">
                <!-- <div class="crisis-btn-wrapper">
                    <img :src="require('@/assets/icons/share.svg')"></img>
                    <p class="home-btn-text">Share</p>
                </div> -->

                <button class="crisis-btn-wrapper" @click="goToHome()">
                    <img :src="require('@/assets/icons/home.svg')" alt="">
                    <p class="home-btn-text">Go to Dashboard</p>
                </button>

                <button class="crisis-btn-wrapper" :disabled="downloadLoader" @click="downloadCrisisDoc()">

                    <div class="download-wrapper">
                        <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                        <p>Download</p>
                        <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </div>

                </button>
            </div>
        </div>

        <div v-else class="completed-doc-header-left">
            <div class="doc-name-editor-wrapper">
                <span class="doc-title">{{ docName }}</span>
                <RenamePopup v-if="isEditingTitle" :docName="docName" :isEditing="isEditingTitle"
                    :id="$route.params.crisisDocumentId" flowType="crisis" @update-isEdit="isEditingTitle = $event"
                    @updated-prTitle="docName = $event" />
                <button class="edit-btn" @click="isEditingTitle = true">
                    <img :src="require('@/assets/icons/edit.svg')" />
                </button>
            </div>

        </div>
        <div class=version-toggle-container>
            <div class="version-toggle">
                <button :class="['toggle-btn', { active: activeVersion === 'final' }]" @click="toggleCrisis('final')">
                    Finalized Version
                </button>
                <button v-if="ceoContent" :class="['toggle-btn', { active: activeVersion === 'ceo' }]"
                    @click="toggleCrisis('ceo')">
                    CEO Crisis Memo
                </button>
                <button v-if="employeeContent" :class="['toggle-btn', { active: activeVersion === 'employee' }]"
                    @click="toggleCrisis('employee')">
                    Employee Talking Points
                </button>
               
            </div>
            <div v-if=" !ceoContent || !employeeContent" class="dropdown-wrapper">
                <button class="shorten" @click="toggleDropdown">
                    <p>Options</p>
                    <img :src="require('@/assets/icons/dropdown.svg')" />
                </button>

                <div class="dropdown-menu" v-if="isOpen">
                    <p class="dropdown-title">Generate options</p>

                    <div v-if="!ceoContent" class="dropdown-item" @click="handleCeo">
                        <img :src="require('@/assets/icons/shorten.svg')" />
                        <span>Generate Internal CEO Crisis Memo</span>
                    </div>

                    <div v-if="!employeeContent" class="dropdown-item" @click="handleEmployee">
                        <img :src="require('@/assets/icons/pitch-icon.svg')" />
                        <span>Generate Employee Talking Points</span>
                    </div>
                </div>
            </div>
        </div>


        <div class="body">
            <div class="body-wrapper">
                <div class="body-content" v-html="cleanedCrisisContent"></div>
            </div>
        </div>

    </div>
    <v-overlay :model-value="pageLoader" class="overlay" persistent="true">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Generating</span>
    </v-overlay>

</template>

<script>
import RenamePopup from '@/components/RenamePopup.vue';
import { downloadPr } from '@/helper/downloadPr';
import RotatingLoader from '@/components/CircularProgressBar.vue';
import axiosInstance from '@/axiosInterceptor';
export default {
    data() {
        return {
            downloadLoader: false,
            isEditingTitle: false,
            docName: null,
            activeVersion: 'final',
            isOpen: false,
            mediaContent: null,
            ceoContent: null,
            employeeContent: null,
            pageLoader: false
        }
    },
    components: { RenamePopup, RotatingLoader },
    props: {
        crisisData: { type: Object },
        isCompleted: { type: Boolean },
        modelValue: { type: String }
    },

    computed: {
        cleanedCrisisContent() {
            switch (this.activeVersion) {
                case 'final':
                    return this.crisisData.generatedContent;
                case 'ceo':
                    return this.ceoContent || '';
                case 'employee':
                    return this.employeeContent || ''
                default:
                    return this.crisisData.generatedContent
            }
        }
    },

    watch: {
        docName: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', val);
            }
        },
        activeVersion(val) {
            this.$emit('download-version', val);
        }

    },

    methods: {
        toggleCrisis(version) {
            this.activeVersion = version
            this.$emit('download-version', version);

        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        goToHome() {
            this.$store.dispatch('updateIsGeneratePopup', false);
            this.$router.push({ name: 'CrisisManagementHome' });
        },

        async downloadCrisisDoc() {
            this.downloadLoader = true;
            const payload = {
                crisisDocumentId: this.$route.params.crisisDocumentId,
                flowType: "CRISIS",
                versionType: this.activeVersion
            };
            let documentName = this.modelValue +'_'+ payload.versionType
            await downloadPr(payload, documentName);
            this.downloadLoader = false;
        },

        async handleCeo() {
            this.isOpen = false;
            await this.generateCeoCrisisDoc()
        },
        async handleEmployee() {
            this.isOpen = false;
            await this.generateEmployeeCrisisDoc()

        },
        async generateCeoCrisisDoc() {
            try {
                this.pageLoader = true;
                const response = await axiosInstance.put('/crisis/ceo', {
                    crisisDocumentId: this.$route.params.crisisDocumentId,
                });
                if (response.status == 200) {
                    this.ceoContent = response.data.data.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '').replace(/\n/g, '').trim();
                    this.activeVersion = 'ceo';
                    this.$emit('download-version', this.activeVersion);
                    this.showOriginal = false;
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'save',
                        message: 'CEO version generated successfully',
                    });
                }

            } catch (error) {
                if (error.response?.status === 502 || error.code === 'ERR_NETWORK' || error.response?.status === 504) {
                    let attempts = 0;
                    let maxAttempts = 40;
                    const intervalTime = 15000;
                    const intervalId = setInterval(async () => {
                        attempts++;
                        try {
                            if (this.ceoContent && this.ceoContent.trim() !== "") {
                                clearInterval(intervalId);
                                this.activeVersion = 'ceo';
                                this.$emit('download-version', this.activeVersion);
                                this.showOriginal = false;
                                Eventbus.emit('commonSnackbar', {
                                    snackType: 'save',
                                    message: 'CEO version generated successfully',
                                });

                            } else if (attempts >= maxAttempts) {
                                clearInterval(intervalId);
                                this.pageLoader = false;
                            }

                        } catch (pollError) {
                            console.error("Error during polling:", pollError);
                            clearInterval(intervalId);
                            this.pageLoader = false;
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to generate PR. Please try again later.'
                            });
                        }
                    }, intervalTime);
                }
            } finally {
                this.pageLoader = false;


            }
        },
        async generateEmployeeCrisisDoc() {
            try {
                this.pageLoader = true;
                const response = await axiosInstance.put('/crisis/employee', {
                    crisisDocumentId: this.$route.params.crisisDocumentId,
                });
                if (response.status == 200) {
                    this.employeeContent = response.data.data.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '').replace(/\n/g, '').trim();
                    this.activeVersion = 'employee';
                    this.$emit('download-version', this.activeVersion);
                    this.showOriginal = false;
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'save',
                        message: 'Employee version generated successfully',
                    });
                }

            } catch (error) {
                if (error.response?.status === 502 || error.code === 'ERR_NETWORK' || error.response?.status === 504) {
                    let attempts = 0;
                    let maxAttempts = 40;
                    const intervalTime = 15000;
                    const intervalId = setInterval(async () => {
                        attempts++;
                        try {
                            this.$emit('update:modelValue', this.modelValue);
                            if (this.employeeContent && this.employeeContent.trim() !== "") {
                                clearInterval(intervalId);
                                this.activeVersion = 'employee';
                                this.$emit('download-version', this.activeVersion);
                                this.showOriginal = false;
                                Eventbus.emit('commonSnackbar', {
                                    snackType: 'save',
                                    message: 'Employee version generated successfully',
                                });

                            } else if (attempts >= maxAttempts) {
                                clearInterval(intervalId);
                                this.pageLoader = false;
                            }

                        } catch (pollError) {
                            console.error("Error during polling:", pollError);
                            clearInterval(intervalId);
                            this.pageLoader = false;
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to generate PR. Please try again later.'
                            });
                        }
                    }, intervalTime);
                }
            } finally {
                this.pageLoader = false;


            }
        },
    },

    mounted() {
        this.docName = this.modelValue;
        this.ceoContent = this.crisisData.generatedCeoContent;
        this.employeeContent = this.crisisData.generatedEmployeeContent
        this.$emit('download-version', this.activeVersion);


    }
}
</script>

<style scoped>
.final-crisis {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    width: 80%;
    overflow: auto;
    position: relative;
    gap: 1rem;
    box-sizing: border-box;
}

.final-crisis-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5em;
    background: var(--primary-gradient-bar-with-black);
    padding: 1rem 1.5rem;
    border-radius: 8px;
    color: var(--secondary-font-color);
    justify-content: space-between;
}

.crisis-header-left {
    display: flex;
    gap: 1rem;
}

.crisis-header-right {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.crisis-btn-wrapper {
    display: flex;
    justify-content: center;
    background: #FFFFFF1F;
    gap: 4px;
    padding: 0.5rem 1rem;
    border: 1px solid #FFFFFF33;
    align-items: center;
    border-radius: 8px;
    font-size: var(--normal-font-size);
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.download-wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
}

.completed-doc-header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
}

.doc-name-editor-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}

.doc-title {
    font-size: 24px;
}

.doc-name-editor-wrapper .edit-btn {
    display: flex;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
    background: none;
}

.edit-btn {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 50%;
    border: 1px solid #A3A3A3;
    background: white;
}

.body {
    background-color: var(--secondary-font-color);
    border-radius: 8px;
    padding: 1rem;
    overflow: hidden;
    position: relative;
}

.body-wrapper {
    height: 100%;
    overflow: auto;
    scrollbar-width: none;
    will-change: transform;
}

.body-content {
    display: flex;
    background-color: white;
    flex-direction: column;
    border-radius: 6px;
    padding: 1rem;
    color: black;
    gap: 1rem;
}

.body-content ul {
    padding: 1rem !important;
}

.title {
    display: flex;
    padding: 8px;
    flex: 1;
    justify-content: center;
    align-items: center;
}

.version-toggle-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.version-toggle {
    display: flex;
    gap: 8px;
    border-radius: 5rem;
    padding: 4px;
}

.toggle-btn {
    padding: 8px 20px;
    border: none;
    background: #FFFFFF33;
    color: #E5E5E5;
    cursor: pointer;
    border-radius: 5rem;
    font-size: var(--normal-font-size);
    display: flex;
    align-items: center;
}

.toggle-btn.active {
    background: white;
    color: var(--primary-font-color);
}

.dropdown-wrapper {
    position: relative;
    display: inline-block;
}


.shorten {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    gap: 8px;
    border-radius: 24px;
    border: 1px solid #FFFFFF33;
    color: white;
    cursor: pointer;
    font-size: 16px;
    background: transparent;
}

.dropdown-menu {
    position: absolute;
    top: 48px;
    right: 0;
    width: 260px;
    background: var(--secondary-font-color);
    color: black;
    border-radius: 16px;
    padding: 12px 0;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 9999;
}

.dropdown-title {
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    color: #737373;
    border-bottom: 1px solid #EEEEEE;
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid #EEEEEE;
    cursor: pointer;
}

.dropdown-item img {
    width: 22px;
    height: 22px;
}

.dropdown-item:last-child {
    border-bottom: none;
}
</style>
